module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-book',\n    title: 'Company financials',\n    description: 'Check current and historic financial reports and ledger contents of your company / companies.'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/6-books/books.section-header.html
// module id = 4115
// module chunks = 86